var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Button } from "../button/Button";
import { PreloaderRipple } from "./ripple/Ripple";
var RIPPLE_STYLE_CONFIG = {
  small: {
    marginTop: 40,
    marginBottom: 20
  },
  medium: {
    marginTop: 40,
    marginBottom: 20
  },
  large: {
    marginTop: 40,
    marginBottom: 20
  }
};
function PreloaderInfiniteScroll(_ref) {
  var listener = _ref.listener, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? {
    bottom: -1500,
    top: 0,
    left: 0,
    right: 0
  } : _ref$offset, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$fallbackButtonLa = _ref.fallbackButtonLabel, fallbackButtonLabel = _ref$fallbackButtonLa === void 0 ? null : _ref$fallbackButtonLa, _ref$showFallbackButt = _ref.showFallbackButton, showFallbackButton = _ref$showFallbackButt === void 0 ? false : _ref$showFallbackButt;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(VisibilitySensor, {
    onChange: listener,
    offset,
    scrollCheck: true,
    scrollDelay: 0,
    active: !isLoading
  }), /* @__PURE__ */ React.createElement(PreloaderRipple, {
    isActive: isLoading,
    styleConfig: RIPPLE_STYLE_CONFIG
  }), showFallbackButton ? /* @__PURE__ */ React.createElement(Button, {
    onClick: listener
  }, fallbackButtonLabel) : null);
}
__name(PreloaderInfiniteScroll, "PreloaderInfiniteScroll");
export {
  PreloaderInfiniteScroll
};
